import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styles from "./why.module.scss"
import Img from "gatsby-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function why({ description, lang, meta, keywords, title }) {
  const { site, taxi, com, money, target } = useStaticQuery(
    graphql`
      query {
        site: site {
          siteMetadata {
            websiteConfig {
              about {
                title
                subtitle
                content
              }
            }
          }
        }
        taxi: file(relativePath: { eq: "taxi-mini.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        com: file(relativePath: { eq: "com.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        money: file(relativePath: { eq: "money.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        target: file(relativePath: { eq: "target.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  return (
    <div className={`row ${styles.back} `}>
      <div className="col-lg-12">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              <h2 className={`${styles.h2}`}>
                Démarquez vous sans vous ruinez !
              </h2>
              <p className={styles.p}>
                Un média embarqué dédié à la diffusion d'annonces publicitaires
                et au divertissement via un réseau de tablettes installées dans
                les taxis et VTC en Algérie.
              </p>
              <span className="welcome">Publicités & Marketing</span>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 pb-5">
              <ul className="d-flex align-items-center justify-content-center flex-wrap">
                <li className={styles.li}>
                  <FontAwesomeIcon
                    className={styles.icon}
                    icon="address-book"
                  />
                  <p>Attirer de nouveaux clients</p>
                </li>
                <li className={styles.li}>
                  <FontAwesomeIcon className={styles.icon} icon="chart-line" />
                  <p>PLus de visiteurs sur votre site internet</p>
                </li>
                <li className={styles.li}>
                  <FontAwesomeIcon className={styles.icon} icon="phone" />
                  <p>Recevoir plus d’appels</p>
                </li>
                <li className={styles.li}>
                  <FontAwesomeIcon
                    className={styles.icon}
                    icon="money-check-alt"
                  />
                  <p>Accroissez vos ventes</p>
                </li>
                <li className={styles.li}>
                  <FontAwesomeIcon className={styles.icon} icon="user-check" />
                  <p>Fidéliser vos clients</p>
                </li>
              </ul>
            </div>
          </div>
          <div className="row mt-5" id="services">
            <div className="col-lg-12 p-0">
              <h2>Nos Services</h2>
              <span className="welcome">Publicités & Marketing</span>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-6">
              <Img
                className={` ${styles.image} `}
                imgStyle={{
                  width: "115px",
                  height: "166px",
                  position: "absolute",
                  right: 0,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                fluid={com.childImageSharp.fluid}
              />
              <h3 className={styles.h3}>Un auditoire récéptif</h3>
              <p className="text-center">
                Le TiTAN Media c’est une diffusion dans les taxis, les
                Compagnies Privées, et bientôt dans les trains, les bus, les
                cars, les voitures de location.
              </p>
            </div>
            <div className="col-lg-6">
              <Img
                className={` ${styles.image} `}
                imgStyle={{
                  width: "180px",
                  height: "inherit",
                  right: 0,
                  top: 25,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                fluid={taxi.childImageSharp.fluid}
              />
              <h3 className={styles.h3}>Un environnement inclusif</h3>
              <p className="text-center">
                Le TiTAN Media c’est une diffusion dans les taxis, les
                Compagnies Privées, et bientôt dans les trains, les bus, les
                cars, les voitures de location.
              </p>
            </div>
            <div className="col-lg-6">
              <Img
                className={` ${styles.image} `}
                imgStyle={{
                  width: "180px",
                  right: 0,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                fluid={target.childImageSharp.fluid}
              />
              <h3 className={styles.h3}>Des communications sur mesures</h3>
              <p className="text-center">
                L’ensemble du réseau de diffusion "Le TiTAN Media", permet de
                toucher plusieurs millions de personnes par an, avec une
                visibilité immédiate en ``one to one``
              </p>
            </div>
            <div className="col-lg-6">
              <Img
                className={` ${styles.image} `}
                imgStyle={{
                  width: "180px",
                  right: 0,
                  top: -12,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                fluid={money.childImageSharp.fluid}
              />
              <h3 className={styles.h3}>Une facturation maitrisée</h3>
              <p className="text-center">
                Le TiTAN Media est la nouvelle façon de faire ses compagnes
                publicitaires ! Une campagne de notoriété (OOH) et une campagne
                Go To Store (DOOH) .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default why
